module.exports = __webpack_public_path__ + "static/media/GSSPWEB.cd8a516d.gif";